export default __webpack_public_path__ + "static/media/what_to_do_on_a_yacht.30ea5c9f.webp";